import type { SurveyResponseItem, SurveyQuestion, SurveyStepAnswer } from '../types/survey.types'

function formatAnswerForExport(answer: SurveyStepAnswer | undefined, question: SurveyQuestion): string {
  if (!answer) return ''

  if (question.type === 'multi-select') {
    const parts = answer.values?.length ? [...answer.values] : []
    if (answer.otherText) parts.push(`Others: ${answer.otherText}`)
    return parts.join('; ')
  }

  if (question.type === 'single-select') {
    return answer.value || ''
  }

  if (question.type === 'text') {
    return answer.text || ''
  }

  return ''
}

function escapeCsvValue(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`
  }
  return value
}

export function exportResponsesToCsv(responses: SurveyResponseItem[], questions: SurveyQuestion[], surveyId: string) {
  const sortedQuestions = [...questions].sort((a, b) => a.step - b.step)

  const headers = [
    'Tenant',
    'User',
    'Email',
    'Status',
    ...sortedQuestions.map(q => `Q${q.step}: ${q.label}`),
    'Submitted'
  ]

  const rows = responses.map(r => {
    const status = r.isCompleted
      ? 'Completed'
      : r.isDismissed
        ? 'Dismissed'
        : r.currentStep > 0
          ? `In Progress (Step ${r.currentStep}/${sortedQuestions.length})`
          : 'Not Started'

    return [
      r.tenantName || r.tenantCode,
      r.userEmail || r.userId,
      r.userEmail || '',
      status,
      ...sortedQuestions.map(q => formatAnswerForExport(r.answers?.[String(q.step)], q)),
      r.submittedAt ? new Date(r.submittedAt).toLocaleString() : ''
    ]
  })

  const csvContent = [
    headers.map(escapeCsvValue).join(','),
    ...rows.map(row => row.map(escapeCsvValue).join(','))
  ].join('\n')

  const BOM = '\uFEFF'
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${surveyId}-responses.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
